import { useCallback, useState } from "react";
import { debounce } from "../helpers";
import { useEventListener } from "./useEventListener";

type IDeviceScreenSize = "xs" | "s" | "m" | "l" | "xl";

const getDeviceScreenSize = (width: number): IDeviceScreenSize => {
  if (width < 320) {
    return "xs";
  } else if (width >= 320 && width < 400) {
    return "s";
  } else if (width >= 400 && width < 767) {
    return "m";
  } else if (width >= 767 && width < 1024) {
    return "l";
  }
  return "xl";
};

export const useBreakpoint = (_window = window) => {
  const [breakpoint, setBreakpoint] = useState<IDeviceScreenSize>(() =>
    getDeviceScreenSize(_window.innerWidth)
  );

  const handler = useCallback(
    debounce(() => {
      setBreakpoint(getDeviceScreenSize(_window.innerWidth));
    }, 200),
    []
  );

  useEventListener("resize", handler, _window);

  return {
    isMobile: ["xs", "s", "m"].includes(breakpoint),
    breakpoint,
  };
};
